import Axios from "axios";
import  cookie from "react-cookies";
import { call, put, race, take, takeLatest, select } from "redux-saga/effects";
import { START_DOWNLOAD, STOP_DOWNLOAD } from "../actions/fileDownloadActions";
import { DOWNLOAD_COMPLETED, DOWNLOAD_STARTED, INCREASE_DOWNLOAD_SUCCESS_COUNT, SET_TOTAL_FOR_DOWNLOAD,RESET_DOWNLOAD_STATE_WITH_FAILURES, INCREASE_DOWNLOAD_FAILED_COUNT, ADD_FAILED_DOWNLOAD_FILE } from "../actions/actionTypes";
import { toast } from "react-toastify";
import { API_V2_NODES, CONTENT, OTCS_URL } from "../../config/apiConfig";

const getFileNameWithExtension = (fileName) => {
  const extensionPattern = /\.[^.]+$/;
  const hasValidExtension = extensionPattern.test(fileName) && fileName.split('.').pop().length > 1;
  return hasValidExtension ? fileName : `${fileName}.pdf`;
}

function addBeforeUnloadListener() {
  window.addEventListener("beforeunload", handleBeforeUnload);
}

function removeBeforeUnloadListener() {
  window.removeEventListener("beforeunload", handleBeforeUnload);
}

function handleBeforeUnload(event) {
  event.preventDefault();
  event.returnValue = "Download is in progress. Are you sure you want to leave?";
  return "Download is in progress. Are you sure you want to leave?";
}

function* downloadFile(dataId,fileName,controller,InvoiceNumber){
    try {
        const url = `${OTCS_URL}/${API_V2_NODES}/${dataId}/${CONTENT}`;
        const authToken = cookie.load("serviceToken");
    
        const response = yield call([Axios, Axios.get], url, {
          headers: {
              otdsticket: authToken
          },
          responseType: "blob",
          signal: controller.signal
        });
        yield put({ type: INCREASE_DOWNLOAD_SUCCESS_COUNT });
        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = getFileNameWithExtension(fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    } catch (error) {
        console.error("Error while downloading-", fileName,"error details\n",error);
        const errorFileData = {fileName,InvoiceNumber} 
        debugger
        yield put({type: INCREASE_DOWNLOAD_FAILED_COUNT})
        yield put({type: ADD_FAILED_DOWNLOAD_FILE,data:errorFileData}) 
    }

}

function* handleDownload(action) {
    yield put({type:DOWNLOAD_STARTED});    
    yield put({type:SET_TOTAL_FOR_DOWNLOAD,data:action.payload.length});  
    addBeforeUnloadListener()
    const controller = new AbortController();
    let cancelled = false;
    try {
      for (let document of action.payload) {
        const { stop } = yield race({
          download: call(downloadFile, document.dataId, document.docName, controller, document.InvoiceNumber),
          stop: take(STOP_DOWNLOAD),
        });
        
        if (stop) {
          controller.abort()
          toast.success("Download cancelled")
          cancelled = true;
          yield put({type:DOWNLOAD_COMPLETED});    
          break;
        }
      }

      const failedCount = yield select((state) => state.FileDownloadReducer.countOfDownloadFailed);

      if(failedCount<1 && !cancelled){
        toast.success('Download completed successfully!');
      }

      yield put({type:RESET_DOWNLOAD_STATE_WITH_FAILURES})
    }catch(error){
      yield put({type:DOWNLOAD_COMPLETED});     
    }finally{
      yield put({type:DOWNLOAD_COMPLETED});
      removeBeforeUnloadListener();
    }
  }


export default function* watchFileDownload() {
  yield takeLatest(START_DOWNLOAD, handleDownload);
}
